import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const paProductivityListService = (params: {
  page?: number | null;
  limit?: number | null;
  month?: number | null;
  year?: number | null;
  productivityTemplateId?: string;
  productivityTemplatePeriod?: number;
  cycleId?: string | null;
  empId?: number | null;
  keyword?: string | null;
  departmentId?: number | null;
  jobTitleCode?: string | null;
}) =>
  RestAPIClient.call<Types.PAListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const paProductivitySummaryListService = (params: {
  month?: number | null;
  year?: number | null;
}) =>
  RestAPIClient.call<Types.ProductivitySalaryDetailSummary[]>({
    method: HTTPRequestMethods.GET,
    url: Paths.SummaryList,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const viewPayslipPAService = (params: {
  id: string;
  payslipCode: string;
}) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.GET,
    url: Paths.ViewPayslip,
    config: {
      requireAuthentication: true,
      params: {
        ...params,
      },
    },
  });

export const viewPayslipSummaryPAService = (params: {
  empId: number;
  year: number;
  month: number;
}) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.GET,
    url: Paths.ViewPayslipSummary,
    config: {
      requireAuthentication: true,
      params: {
        ...params,
      },
    },
  });

export const paProductivityBankTransferExportService = (params: {
  page?: number | null;
  limit?: number | null;
  month?: number | null;
  year?: number | null;
  templateId?: string | null;
  templatePeriod?: string | null;
  empId?: number | null;
  keyword?: string | null;
  departmentId?: number | null;
  jobTitleCode?: string | null;
}) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.GET,
    url: Paths.BankTransfer,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const paProductivitySendPayslipService = (params: {
  month?: number;
  year?: number;
  templateId?: string;
  templatePeriod?: number;
  ids?: string[];
  reason?: string;
  empIds?: number[];
}) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.SendPayslip,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const paProductivityPayslipLogCreateService = (params: {
  templateId: string;
  month: number;
  year: number;
  reason: string;
}) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.PayslipLog,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const paProductivityPayslipLogListService = (params: {
  page?: number | null;
  limit?: number | null;
  month?: number | null;
  year?: number | null;
  templateId?: string | null;
  status?: number | null;
}) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.GET,
    url: Paths.PayslipLog,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const paProductivityApprovalStatusService = (params: {
  page?: number | null;
  limit?: number | null;
  month?: number | null;
  year?: number | null;
  templateId?: string | null;
  templatePeriod?: number | null;
  status?: number | null;
  action?: string | null;
}) =>
  RestAPIClient.call<Types.ProductivityApprovalStatusItem>({
    method: HTTPRequestMethods.GET,
    url: Paths.ApprovalStatus,
    config: {
      requireAuthentication: true,
      params,
    },
  });
